<template>
    <div style="display: flex;">
        <div style="overflow: auto;" :style="{ 'height': clientHeight - 70 + 'px' }">
            <van-sidebar v-model="categoryActive" @change="onChange">
                <van-sidebar-item v-for="(item, index) in Categorys" :key="index" :title="item.Name">
                </van-sidebar-item>

            </van-sidebar>
        </div>
        <div style="width: calc(100% - 82px);overflow: auto;" :style="{ 'height': clientHeight - 70 + 'px' }">
            <CarouselAdvert></CarouselAdvert>
            <div v-for="(item, index) in Categorys" :key="index">

                <div class="category_content_itemtitle" :id="'category_anchor' + index">
                    {{ item.Name }}({{ index }})
                </div>

                <div class="product_content" v-for="(product, indexs) in item.Products" :key="indexs"
                    @touchend="testtouchcancel(index)">
                    <StoreProductBroadwise :ProductItem="product" />
                </div>
            </div>
            <p style="text-align: center;">Powered by Jiecheng</p>
        </div>
    </div>
    <StoreTabbar :active="'storeorder'" />
</template>
<script >
import CarouselAdvert from "../../components/CarouselAdvert.vue"
import axios from "../../commons/AxiosMethod.js"
import StoreProductBroadwise from "../../components/tabbars/StoreProductBroadwise.vue"
import StoreTabbar from "../../components/tabbars/StoreShoppingCartTabbar.vue"

import { Collapse, CollapseItem, Tab, Tabs } from "vant"
export default {
  data () {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,

      active: "",
      Categorys: [], // 分类列表
      CategoryOpt: {}, // 当前分类
      TableId: '',
      itemIndex: 0,
      categoryActive: 0

    }
  },
  name: "App",
  mounted () {
    localStorage.setItem("Cache-TableId", this.$route.query.tableId)
    this.TableId = localStorage.getItem("Cache-TableId")

    this.GetCategorys()
  },
  components: {
    StoreProductBroadwise,
    StoreTabbar,
    CarouselAdvert
  },
  methods: {
    testtouchcancel (event) {
      this.categoryActive = event
    },

    onChange (index) {
      this.itemIndex = index
      const targetElement = document.getElementById('category_anchor' + index)
      if (targetElement) {
        targetElement.scrollIntoView({
          block: 'start',
          inline: 'nearest',
          behavior: 'smooth'
        })
      }
    },
    // 获取分类
    GetCategorys () {
      var param = {
        Where: {
          TableId: this.TableId
        }

      }
      axios.apiMethod(
        "/Store/StoreOrder/GetCategoryProductSimple",
        "post",
        param,
        (result) => {
          this.Categorys = result.Data
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.category_content_itemtitle {
    background-color: #f7f6f6;
    font-size: 12pt;
    font-weight: 700;
    font-size: 14pt;
    padding: 10px 20px;
}

.search_content {
    height: 70px;
    display: flex;

    .search {
        width: 100%;
    }
}

.category_title_menu {
    width: 100%;
    background-color: #fff;
    top: 0px;
    z-index: 9090000;
    border-bottom: 1px solid #eee;
}

.product_content {
    width: calc(100% - 20px);
    margin: 0 auto;
    padding: 5px !important;

    background-color: #f7f6f6;

    .product_item {
        width: calc(100% - 20px);
        margin: 0 auto;
        margin-top: 10px;
    }
}
</style>
